angular
  .module("AccountingBoxApp")
  .controller("ReportingJournalsCtrl", function(
    $scope,
    $http,
    $state,
    FileUploader,
    LoopBackAuth,
    Journal,
    Rapporting,
    Sale,
    Purchase,
    BankTransaction,
    BankAccount
  ) {
    $scope.order = {
      by: "date",
      reverse: false,
      filter: ""
    };
    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };

    var vm = this;
    vm.search = "";

    vm.dates = {
      startDate: moment().startOf("day"),
      endDate: moment().endOf("day")
    };

    //Watch for date changes
    $scope.$watch(
      "rj.dates",
      function(newDate) {
        console.log("New date set: ", newDate);
        vm.dateChanged();
      },
      false
    );

    vm.dateChanged = function() {
      console.log("date changed", vm.dates);
      if (!vm.dates.startDate || !vm.dates.endDate) return;
      var beginDate = vm.dates.startDate.toDate();
      var endDate = vm.dates.endDate.toDate();
      vm.loading = true;
      vm.journals = Journal.find(
        {
          filter: {
            include: [{ journalLines: { include: "account" } }],
            where: {
              date: { between: [beginDate, endDate] }
            }
          }
        },
        function(journals) {
          vm.loading = false;
        }
      );
    };
    // vm.dateChanged();

    vm.getJournals = function(query) {
      query = query.toLowerCase();
      return _.filter(vm.journals, function(journal) {
        return _.some(journal.journalLines, function(journalLine) {
          return (
            _.contains(journalLine.description.toLowerCase(), query) ||
            _.contains(journalLine.amount.toString(), query) ||
            _.contains(journalLine.account.description.toLowerCase(), query) ||
            _.contains(journalLine.account.accountNumber.toString(), query) ||
            (journalLine.subAccount &&
              _.contains(
                journalLine.subAccount.description.toLowerCase(),
                query
              ))
          );
        });
      });
    };

    vm.noResults = function() {
      return !vm.loading && vm.getJournals(vm.search).length === 0;
    };

    vm.toTransaction = function(journal) {
      var to = journal.transactionType.toLowerCase() + "s";
      if (journal.transactionType.toLowerCase() === "journalentry") {
        to = "journalEntries";
      }

      $state.go("app.company.edit." + to, {
        id: journal.transactionId
      });
    };
  });
